import React from "react";
import {
  App,
  AppToolbar,
  Breadcrumbs,
  Card,
  Typography,
} from "@nokia-csf-uxr/ccfk";
import { Body } from "Components/Body";
import Header from "Components/Header";
import LoadingOverlay from "react-loading-overlay-ts";
import { useSelector } from "react-redux";
import { RootState } from "Store/mainStore";
import error403Image from "Assets/Icons/Error-403.svg";
import { AppHeader } from "@nokia-csf-uxr/ccfk/App";
import {
  AppToolbarTitle,
  AppToolbarTitleContainer,
} from "@nokia-csf-uxr/ccfk/AppToolbar";
import {
  BreadcrumbCompacts,
  BreadcrumbCompactsHeader,
} from "@nokia-csf-uxr/ccfk/Breadcrumbs";

const DownTimeHeader = () => {
  return (
    <AppHeader>
      <AppToolbar elevationProps={{ elevationIndex: 0 }}>
        <AppToolbarTitleContainer
          style={{ maxWidth: "100%", padding: "0", margin: "2px 0 0 2px" }}
        >
          <AppToolbarTitle>
            <Breadcrumbs className="dot__Breadcrumbs">
              <BreadcrumbCompacts>
                <BreadcrumbCompactsHeader>
                  <div className="dot-beadcrumb-navbar">
                    <div className="dot-beadcrumb-nav-item">Down time</div>
                  </div>
                </BreadcrumbCompactsHeader>
              </BreadcrumbCompacts>
            </Breadcrumbs>
          </AppToolbarTitle>
          {/* <AppToolbarSubtitle>{prop.subtitle}</AppToolbarSubtitle> */}
        </AppToolbarTitleContainer>
        {/* <AppToolbarButtonRow><Typography variant={'BODY'}>{prop.subtitle}</Typography></AppToolbarButtonRow> */}
      </AppToolbar>
    </AppHeader>
  );
};

interface DowntimeProps {
  title?: string;
  message?: string;
  isAppDown?: boolean;
}
const Downtime = ({ title, message, isAppDown = false }: DowntimeProps) => {
  const authSelector = useSelector((state: RootState) => state.authSlice);
  let crumbs = ["Down time"];

  if (isAppDown) {
    return (
      <Card
        focusEffect={false}
        style={{ textAlign: "center", padding: "20px" }}
      >
        <div
          className="access-denied-wrapper"
          style={{
            height: "94vh",
            boxShadow: "10px 10px 10px #ccc",
            borderRadius: "8px",
          }}
        >
          <div className="access-denied-content">
            <p style={{ textAlign: "center" }}>
              <img src={error403Image} alt="403-Error" />
            </p>
            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              <h5
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginBlockStart: "0",
                  marginBlockEnd: "0",
                  marginBottom: ".5rem",
                  textAlign: "center",
                }}
              >
                {title || "Page Under Maintenance"}
              </h5>
              <Typography style={{ color: "#333333" }}>
                {message ||
                  "Sorry, the page you are looking for is currently under maintenance, please check back later."}
              </Typography>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <LoadingOverlay
      active={authSelector.system.isLoading}
      spinner
      classNamePrefix="MyLoader_"
      text="Please wait "
    >
      <App>
        <Header />
        <Body
          crumbs={crumbs}
          AppHeader={<DownTimeHeader />}
          bodyContent={
            <Card
              focusEffect={false}
              style={{ textAlign: "center", padding: "20px" }}
            >
              <div className="access-denied-wrapper">
                <div className="access-denied-content">
                  <p style={{ textAlign: "center" }}>
                    <img src={error403Image} alt="403-Error" />
                  </p>
                  <div style={{ textAlign: "center", marginTop: "1rem" }}>
                    <h5
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        marginBlockStart: "0",
                        marginBlockEnd: "0",
                        marginBottom: ".5rem",
                        textAlign: "center",
                      }}
                    >
                      {title || "Page Under Maintenance"}
                    </h5>
                    <Typography style={{ color: "#333333" }}>
                      {message ||
                        "Sorry, the page you are looking for is currently under maintenance, please check back later."}
                    </Typography>
                  </div>
                </div>
              </div>
            </Card>
          }
        />
      </App>
    </LoadingOverlay>
  );
};

export default Downtime;
